<template>
  <div id="project" class="active-projects">
    <div
      class="film-content"
      v-for="(project, index) in activeProjects"
      :key="index"
    >
      <div class="film">
        <h1>{{ project.title }}</h1>
        <div class="video-placeholder" v-if="placeholder">
          <img src="@/assets/svg/cookies.svg" />
          <h2>Cookie Error!</h2>
          <p>
            Das YouTube Video konnte nicht geladen werden. Du muss die
            <router-link class="route" to="/impressum"
              >Cookie Bedingungen</router-link
            >
            akzeptieren.
          </p>
          <button class="btn-small btn-blue" @click="cookieSettings()">
            Cookie Einstellungen
          </button>
        </div>
        <iframe
          width="560"
          height="315"
          :src="`${project.video}`"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
          v-if="cookieAccept"
        ></iframe>
      </div>

      <table class="rolls">
        <tr class="roll" v-for="(roll, index) in project.rolls" :key="index">
          <td class="roll-title">
            <b>{{ roll.title }}</b>
          </td>
          <td v-html="roll.name">{{ roll.name }}</td>
        </tr>
      </table>

      <div class="project-text">
        <p v-html="project.description">{{ project.description }}}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  title() {
    return `Filmprojekt - Ocular`;
  },
  data() {
    return {
      cookieAccept: false,
      placeholder: true,
    };
  },
  computed: {
    projects() {
      return this.$store.state.projects;
    },
    activeProjects: function () {
      return this.$store.state.projects.filter((project) => {
        return project.path.match(this.$route.params.filmName);
      });
    },
  },
  created() {
    const getGDPR = localStorage.getItem("GDPR:accepted");

    if (typeof getGDPR !== "undefined" && getGDPR === "true") {
      this.cookieAccept = true;
    } else if (typeof getGDPR !== "undefined" && getGDPR === "false") {
      this.cookieAccept = false;
    }
    if (this.cookieAccept === false) {
      this.placeholder = true;
    } else {
      this.placeholder = false;
    }
  },
  methods: {
    cookieSettings() {
      localStorage.clear();
      location.reload();
    },
  },
};
</script>
<style lang="scss" scoped>
#project {
  .film-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .film {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 10vw 0 0 0;
      h1{
        text-transform: inherit;
      }
      .video-placeholder {
        padding: 2vw 10vw 2vw 10vw;
        width: 55vw;
        height: 30.9375vw;
        background: #ebebeb;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-evenly;
        h2 {
          font-weight: 700;
          margin: 0;
          text-transform: uppercase;
        }
        img {
          width: 13vw;
        }
        p {
          .route {
            font-weight: 600;
          }
        }
      }
      iframe {
        width: 55vw;
        height: 30.9375vw;
        margin-bottom: 4rem;
        border-radius: 10px;
      }
    }
    .rolls {
      display: flex;
      flex-direction: column;
      background-color: #ebebeb;
      padding: 2vw;
      border-radius: 10px;
      .roll {
        display: flex;
        align-items: flex-start;
        .roll-title {
          text-align: right;
        }
        td {
          font-family: canada-type-gibson, "Arial", Helvetica, sans-serif;
          font-size: 2rem;
          font-weight: 400;
          text-align: left;
          width: 25.5vw;
          padding: 1rem 1rem 1rem 1rem;
          color: #1f2d35;
          line-height: 2.5rem;
          b {
            font-weight: 600;
            text-align: right;
          }
        }
      }
    }
    .project-text {
      width: 55vw;
      padding:3vw 0 10vw 0;
      display: flex;
      align-items: center;
      text-align: left;
    }
  }
}
@media only screen and (max-width: 1024px) {
  #project {
    .film-content {
      .film {
        padding: 15vh 0 0 0;
        .video-placeholder {
          padding: 4vw;
          width: 90vw;
          height: calc(80vw / 1.3);
          background: #ebebeb;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-evenly;
          h2 {
            margin: 0;
          }
          img {
            display: none;
          }
          button {
            width: 50vw;
            height: calc(50vw / 5);
            font-size: 3vw;
          }
        }
        iframe {
          width: 90vw;
          height: calc(90vw * 0.5625);
          margin-bottom: 4rem;
        }
      }
      .rolls {
        justify-content: center;
        padding: 3vw;
        border-radius: 15px;
        .roll {
          td {
            font-size: 3.5vw;
            width: 47vw;
          }
        }
      }
      .project-text {
        width: 100%;
        padding: 10vw;
      }
    }
  }
}
</style>
